module.exports = __webpack_public_path__ + "img/607fa86.jpg";